/**
* @file The insight container component for dynamically inject an insight
* @author Heino Lenting
*/
import { ViewContainerRef, Injector, ComponentFactoryResolver } from '@angular/core';
import { InsightProvider } from '../insight-provider';
import { HttpClient } from '@angular/common/http';
import { ComponentRegistry } from '../../core/component-registry';
/**
 * Class for the insight container that dynamicly create insights.
 */
var InsightContainerComponent = /** @class */ (function () {
    /**
     * Constructs a InsightContainerComponent
     * @param containerRef
     * @param resolver
     */
    function InsightContainerComponent(containerRef, factoryResolver, http) {
        this.containerRef = containerRef;
        this.factoryResolver = factoryResolver;
        this.http = http;
        /**
         * Holds the input child component.
         */
        this.childComponent = undefined;
    }
    Object.defineProperty(InsightContainerComponent.prototype, "insight", {
        /**
         * This input receives the insight component type and is used to create an insight of this type dynamicly.
         * @param component The path to the child component almost like the from path of an import clause, except
         * it ends with the component name and not with the module name. Used to get the child component constructor
         * dynamically at runtime (f.e. core/insights/src/components/InsightListComponent).
         */
        set: function (value) {
            var _this = this;
            this.childComponent = value;
            if (this.childComponent === undefined) {
                return;
            }
            // Create insight component.
            var insightType = ComponentRegistry.getComponent('insight', this.childComponent.component);
            var componentFactory = this.factoryResolver.resolveComponentFactory(insightType);
            // https://stackoverflow.com/questions/45585606/staticinjector-vs-reflectiveinjector-in-angular
            var injector = Injector.create([
                {
                    provide: InsightProvider,
                    useFactory: function () {
                        return new InsightProvider(_this, _this.http);
                    },
                    deps: []
                }
            ]);
            this.containerRef.createComponent(componentFactory, 0, injector, []);
        },
        enumerable: true,
        configurable: true
    });
    return InsightContainerComponent;
}());
export { InsightContainerComponent };
